import { useCallback, useEffect, useState } from 'react';

import { getFlightCampaign } from '~/services/FlightsService';

export function useFlightCampaign(id: string) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [data, setData] = useState<App.FlightCampaign>();

  const fetchCampaignData = useCallback(async () => {
    setLoading(true);

    try {
      const { result } = await getFlightCampaign(id);
      setData(result);
    } catch (error) {
      setError(error);
    }

    setLoading(false);
  }, [id, setData, setLoading, setError]);

  useEffect(() => {
    fetchCampaignData();
  }, [fetchCampaignData]);

  return { loading, error, data, revalidate: fetchCampaignData };
}
